var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-footer"},[_c('span',{staticClass:"u-margin-bottom-responsive"},[_c('small',{domProps:{"innerHTML":_vm._s(
                _vm.trans('order.support', {
                    email: this.supportEmail,
                    phone: this.supportPhone,
                    phoneHref: this.supportPhoneHref
                })
            )}})]),_c('small',{staticClass:"product__title-meta | u-margin-bottom-responsive"},[_vm._v(_vm._s(_vm.trans('order.tax')))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }